<template>
  <div>
    <!-- mean it's not a V5 portal yet -->
    <v-alert v-if="isMigrationSucess" type="success">
      La migration a bien été effectuée.
    </v-alert>
    <v-alert v-if="isMigrationError" type="danger">
      Une erreur est survenue lors de la migration.
    </v-alert>

    <v-row v-if="group.portal != '3'">
      <v-col cols="12">
        <v-card>
          <v-card-title>Groupe v4</v-card-title>
          <v-card-text>
            <v-alert type="error">
              Attention Groupe en v4, la configuration se fait
              <a
                :href="
                  'https://passman01.wifipass.org/w2a/backoffice.php/application/page/group/' +
                  group.description +
                  '/group-' +
                  group.id +
                  '/?target=/w2a/backoffice.php/group_environment/' +
                  group.id +
                  '/page'
                "
                target="_blank"
                >ici</a
              >
            </v-alert>
            <div v-if="group.portal == 2 && group.isBuiltin == false">
              <v-btn
                @click="openConfirmDialogForV4 = true"
                color="primary"
                :disabled="
                  isGroupMigrable != null &&
                  (isGroupMigrable.facebook || isGroupMigrable.pms)
                "
                >Migrer le groupe en V5</v-btn
              >
              <p v-if="isGroupMigrable != null && isGroupMigrable.facebook">
                Le groupe est configuré avec Facebook, option non supportée sur
                les V5.
              </p>
              <p v-if="isGroupMigrable != null && isGroupMigrable.pms">
                Le groupe est configuré avec la PMS, option non supportée sur
                les V5.
              </p>
            </div>
            <div v-else-if="group.portal == 2 && group.isBuiltin == true">
              <migrate-group-built-in
                :isGroupMigrableParent="isGroupMigrable"
                :group="group"
              ></migrate-group-built-in>
            </div>
            <div v-else>
              <v-btn @click="openConfirmDialogForV3 = true" color="primary"
                >Migrer le groupe de V3 vers V5</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <confirm-dialog
      :open.sync="openConfirmDialogForV3"
      v-on:cancel="openConfirmDialogForV3 = false"
      v-on:confirm="migrateGroupV3ToV5(group.id)"
    >
      <template #title> Demande de confirmation </template>
      <slot name="confirm-text">
        La migration du groupe, migre également tous les portails configurés en
        "héritage groupe" appartenant à ce groupe. <br />
        Êtes-vous sûr.e de vouloir migrer ce groupe ?
      </slot>
    </confirm-dialog>
    <confirm-dialog
      :open.sync="openConfirmDialogForV4"
      v-on:cancel="openConfirmDialogForV4 = false"
      v-on:confirm="migrateGroup(group.id)"
    >
      <template #title> Demande de confirmation </template>
      <slot name="confirm-text">
        La migration du groupe, migre également tous les portails configurés en
        "héritage groupe" appartenant à ce groupe. <br />
        Êtes-vous sûr.e de vouloir migrer ce groupe ?
      </slot>
    </confirm-dialog>
  </div>
</template>
<script>
import { defineComponent, onMounted, ref, toRefs } from "@vue/composition-api";
import { useMigrationPortal } from "@/composables/migation-portal";
import MigrateGroupBuiltIn from "./MigrateGroupBuiltIn";
import ConfirmDialog from "../General/ConfirmDialog";

export default defineComponent({
  components: {
    ConfirmDialog,
    MigrateGroupBuiltIn,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    /* Import des API */
    const {
      migrationPortalData,
      migrateGroup,
      migrateGroupV3ToV5,
      groupIsMigrable,
    } = useMigrationPortal();

    const openConfirmDialogForV3 = ref(false);
    const openConfirmDialogForV4 = ref(false);

    onMounted(() => {
      groupIsMigrable(props.group.id);
    });
    return {
      ...toRefs(migrationPortalData),
      migrateGroup,
      migrateGroupV3ToV5,
      openConfirmDialogForV4,
      openConfirmDialogForV3,
    };
  },
});
</script>
